// extracted by mini-css-extract-plugin
export default {"bdtInfo":"Nagad_bdtInfo__ittOO","billingAccountInput":"Nagad_billingAccountInput__-asp7","copyIcon":"Nagad_copyIcon__WXxR1"};